import React from 'react';
import { Card } from '../components/ui/card';

function AdminHelp() {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="p-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Center za pomoč</h1>
        <p className="text-gray-600">Center za pomoč je še v izgradnji</p>
      </Card>
    </div>
  );
}

export default AdminHelp;
